import { createGlobalStore } from 'hox';
import { useState, useEffect } from 'react';
import { setJwtToken, setAdminJwtToken } from '@bitbot/api';

export const [useToken] = createGlobalStore(() => {
  const [tradeLoginStatus, setTradeLoginStatus] = useState<boolean>(() => {
    try {
      const token = localStorage.getItem('trade_token');
      return !!token;
    } catch {
      return false;
    }
  });
  const [tradeToken, setTradeToken] = useState<string | undefined>(() => {
    try {
      const token = localStorage.getItem('trade_token');
      return token ?? undefined;
    } catch {
      return undefined;
    }
  });
  const [token, setToken] = useState<string | undefined>(() => {
    try {
      const token = localStorage.getItem('tg_token');
      return token ?? undefined;
    } catch {
      return undefined;
    }
  });

  const _setTradeToken = (token: string | undefined) => {
    setTradeToken(token);
    if (token === undefined) {
      localStorage.removeItem('trade_token');
    } else {
      localStorage.setItem('trade_token', token);
    }
  };

  const _setToken = (token: string) => {
    setToken(token);
    localStorage.setItem('tg_token', token);
  };

  useEffect(() => {
    if (!!tradeToken) {
      setJwtToken(tradeToken);
      setAdminJwtToken(tradeToken);
      setTradeLoginStatus(true);
    } else if (!!token) {
      setJwtToken(token);
      setAdminJwtToken(token);
      setTradeLoginStatus(false);
    }
  }, [token, tradeToken]);

  return {
    token,
    tradeToken,
    setToken: _setToken,
    setTradeToken: _setTradeToken,
    hasLogin: !!token,
    hasTradeLogin: !!tradeToken,
    tradeLoginStatus,
    setTradeLoginStatus,
  };
});
